(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boostly-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (!root || root.dataset.interactiveReady === 'true') return;
      root.dataset.interactiveReady = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const heroScene = root.querySelector('[data-hero-scene]');
      if (heroScene) {
        const sceneButtons = heroScene.querySelectorAll('[data-scene-button]');
        const sceneNote = heroScene.querySelector('[data-scene-note]');
        const sceneLabels = {
          site: 'Website signal active',
          reviews: 'Review signal active'
        };
        sceneButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const mode = button.dataset.sceneButton;
            heroScene.dataset.mode = mode;
            sceneButtons.forEach((item) => item.classList.toggle('is-active', item === button));
            if (sceneNote) sceneNote.textContent = sceneLabels[mode];
          });
        });
        if (!reducedMotion && window.matchMedia('(pointer: fine)').matches) {
          heroScene.addEventListener('pointermove', (event) => {
            const rect = heroScene.getBoundingClientRect();
            const x = (event.clientX - rect.left) / rect.width - 0.5;
            const y = (event.clientY - rect.top) / rect.height - 0.5;
            heroScene.style.setProperty('--scene-x', `${(-y * 4).toFixed(2)}deg`);
            heroScene.style.setProperty('--scene-y', `${(8 + x * 5).toFixed(2)}deg`);
          });
          heroScene.addEventListener('pointerleave', () => {
            heroScene.style.setProperty('--scene-x', '0deg');
            heroScene.style.setProperty('--scene-y', '8deg');
          });
        }
      }

      const revealItems = root.querySelectorAll('.b-path, .b-websites__copy, .b-work__head, .b-work__project, .b-moment, .b-product-card, .b-why__list article, .b-instagram__card, .b-faq details, .b-final');
      revealItems.forEach((item) => item.classList.add('b-reveal'));
      if (reducedMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      } else {
        root.classList.add('b-enhanced');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -45px' });
        revealItems.forEach((item) => observer.observe(item));
      }

      if (window.matchMedia('(pointer: fine)').matches) {
        root.querySelectorAll('.b-path, .b-work__project, .b-flow > div, .b-product-card, .b-why__list article, .b-instagram__card').forEach((card) => {
          card.classList.add('b-spotlight');
          card.addEventListener('pointermove', (event) => {
            const rect = card.getBoundingClientRect();
            card.style.setProperty('--spot-x', `${event.clientX - rect.left}px`);
            card.style.setProperty('--spot-y', `${event.clientY - rect.top}px`);
          });
        });
      }

      const demo = root.querySelector('[data-tap-demo]');
      const trigger = root.querySelector('.b-demo-trigger');
      const status = root.querySelector('.b-demo-status');
      if (demo && trigger && status) {
        const steps = Array.from(demo.querySelectorAll('[data-flow-step]'));
        let timers = [];
        const updateStatus = (title, detail) => {
          status.querySelector('b').textContent = title;
          status.querySelector('small').textContent = detail;
        };
        trigger.addEventListener('click', () => {
          timers.forEach(window.clearTimeout);
          timers = [];
          steps.forEach((step) => step.classList.remove('is-active'));
          trigger.disabled = true;
          const sequence = [
            ['Great experience captured', 'Your customer is happiest right now.'],
            ['NFC tap detected', 'Their phone connects instantly—no app needed.'],
            ['Google review page opened', 'The path to genuine feedback is ready.']
          ];
          steps.forEach((step, index) => {
            timers.push(window.setTimeout(() => {
              steps.forEach((item) => item.classList.remove('is-active'));
              step.classList.add('is-active');
              updateStatus(sequence[index][0], sequence[index][1]);
            }, index * (reducedMotion ? 120 : 720)));
          });
          timers.push(window.setTimeout(() => {
            trigger.disabled = false;
            updateStatus('Demo complete', 'That is the full customer journey—in seconds.');
          }, reducedMotion ? 500 : 2550));
        });
      }
    };

    document.querySelectorAll('.b-home').forEach(setup);
    document.addEventListener('shopify:section:load', (event) => setup(event.target.querySelector('.b-home')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
